export const getVWATestHash = (slug, hash, testFlags, device) => {
    try {
        const { ssrTest } = testFlags;
        const { vwaSort } = ssrTest || {};
        const { behpModel, target = ['laptops', 'desktops', 'printers'] } = vwaSort || {};
        const [dir, path] = slug.split('/');
        const behpDeviceType = device === 'desktop' ? 'desktop' : 'mobile';
        return behpModel && (!hash || hash === 'sync') && target.includes(path)
            ? `sync:behpModel=${behpModel}&device=${behpDeviceType}`
            : undefined;
    } catch (e) {}
};
